/* unplugin-vue-components disabled */import { render } from "./CollectUserInfo.vue?vue&type=template&id=1990b76d&scoped=true"
import script from "./CollectUserInfo.vue?vue&type=script&lang=js"
export * from "./CollectUserInfo.vue?vue&type=script&lang=js"

import "./CollectUserInfo.vue?vue&type=style&index=0&id=1990b76d&scoped=true&lang=css"

import exportComponent from "/Users/rabbuse/Project/Vue/txgynew-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1990b76d"]])

export default __exports__